export default __webpack_public_path__ + "static/media/fiat_mask.d071ae69.svg";